<template>
  <form
    class="input-phone"
  >
    <label
      v-if="name"
      :for="name"
      class="input-phone__input-label"
      name="number or code"
    >{{ label }}</label>
    <div
      class="input-phone__input-and-lada"
      :class="inputClass"
    >
      <div
        class="input-phone__lada"
        name="lada"
        :class="`bg-${color}`"
      >
        <label
          :for="name"
          class="input-phone__label"
        >{{ lada }}</label>
      </div>
      <input
        v-if="onlyNumbers"
        :id="name"
        v-only-number
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :maxLength="maxLength"
        :value="value"
        :class="['input-phone__input', inputClass]"
        @input="$emit('input', $event.target.value)"
        @keydown.enter="(e) => { e.preventDefault(); $emit('enter', e); }"
        @focus="onFocus"
      />
      <input
        v-else
        :id="name"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :maxLength="maxLength"
        :value="value"
        :class="['input-phone__input', inputClass]"
        @input="$emit('input', $event.target.value)"
        @keydown.enter="(e) => { e.preventDefault(); $emit('enter', e); }"
        @focus="onFocus"
      />
      <button
        v-show="value"
        aria-label="Close alert"
        type="button"
        class="input-phone__reset-button"
        name="deletenumber"
        @click="$emit('input', '')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'InputPhone',
  props: {
    type: { type: String, default: 'text' },
    lada: { type: String, required: true },
    name: { type: String, required: true },
    label: { type: String, default: '' },
    value: { type: String, required: true },
    placeholder: { type: String, default: '' },
    pattern: { type: String, default: '' },
    onlyNumbers: { type: Boolean, default: false },
    maxLength: { type: Number, default: 8 },
    color: { type: String, default: 'red' },
    inputClass: { type: String, default: '' }
  },
  methods: {
    onFocus(event) {
      this.$emit('focus', event);
    }
  }
};
</script>
